import store from "../store";
export default class SideBySideContext {
  constructor() {
    this.displayAnnotation = false;
    this.leftContext = null;
    this.rightContext = null;
    this.sync = false;
  }

  refreshImages() {
    return store.dispatch("loadImagesForSideBySide");
  }
}

